

export async function collect<T = unknown, TReturn = any>(generator: AsyncGenerator<T, TReturn, unknown>, collector: (value: T) => any | Promise<any>) {
    for await (const value of generator) {
        await collector(value);
    }
}